import { TradingSetup, ChartConfig } from '../types';

const STORAGE_KEY = 'tradingview-setup';

export const defaultSetup: TradingSetup = {
  charts: [
    { id: 'chart-1', symbol: 'BTCUSDT', interval: '1', studies: ['RSI@tv-basicstudies'] },
    { id: 'chart-2', symbol: 'BTCUSDT', interval: '5', studies: ['RSI@tv-basicstudies'] },
    { id: 'chart-3', symbol: 'ETHUSDT', interval: '15', studies: ['RSI@tv-basicstudies'] },
    { id: 'chart-4', symbol: 'ETHUSDT', interval: '30', studies: ['RSI@tv-basicstudies'] },
    { id: 'chart-5', symbol: 'SOLUSDT', interval: '60', studies: ['RSI@tv-basicstudies'] },
  ],
  theme: 'dark',
  timezone: 'Asia/Kolkata',
  locale: 'en',
};

export const saveTradingSetup = (setup: TradingSetup): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(setup));
  } catch (error) {
    console.error('Failed to save trading setup:', error);
  }
};

export const loadTradingSetup = (): TradingSetup => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      // Ensure all required properties exist
      return {
        ...defaultSetup,
        ...parsed,
        charts: parsed.charts || defaultSetup.charts,
      };
    }
  } catch (error) {
    console.error('Failed to load trading setup:', error);
  }
  return defaultSetup;
};

export const generateCharts = (count: number): ChartConfig[] => {
  const symbols = ['BTCUSDT', 'ETHUSDT', 'SOLUSDT'];
  const intervals = ['1', '5', '15', '30', '60', '240', 'D', 'W'];
  
  const charts: ChartConfig[] = [];
  
  for (let i = 0; i < count; i++) {
    const symbolIndex = i % symbols.length;
    const intervalIndex = i % intervals.length;
    
    charts.push({
      id: `chart-${i + 1}`,
      symbol: symbols[symbolIndex],
      interval: intervals[intervalIndex],
      studies: ['RSI@tv-basicstudies']
    });
  }
  
  return charts;
};

export const updateChartConfig = (chartId: string, updates: Partial<ChartConfig>): TradingSetup => {
  const currentSetup = loadTradingSetup();
  
  const updatedCharts = currentSetup.charts.map(chart =>
    chart.id === chartId ? { ...chart, ...updates } : chart
  );
  
  const updatedSetup = {
    ...currentSetup,
    charts: updatedCharts,
  };
  
  saveTradingSetup(updatedSetup);
  return updatedSetup;
};
